(function(){
  if(window.__bcOct)return; window.__bcOct=true;
  /* CONTADOR DIARIO: true = se reinicia todos los días a las 00:00 (hora de Chile) y cuenta 24 horas, sin fecha final. Para detenerlo: false y poner la fecha final en snippets/bc-oct-window.liquid (en_iso). */
  var DAILY=true;
  var TZ='America/Santiago';
  function nextMidnight(now){
    var p=new Intl.DateTimeFormat('en-GB',{timeZone:TZ,hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(new Date(now));
    var g=function(t){return +p.filter(function(x){return x.type===t})[0].value};
    return now+(86400-(g('hour')*3600+g('minute')*60+g('second')))*1000;
  }
  function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f)}
  ready(function(){
    var roots=[].slice.call(document.querySelectorAll('[data-bc-root]'));
    if(!roots.length)return;
    var cd=document.querySelector('[data-bc-count]');
    var r0=(cd&&cd.closest('[data-bc-root]'))||roots[0];
    var start=new Date(r0.dataset.start).getTime();
    var end=r0.dataset.end?new Date(r0.dataset.end).getTime():NaN;
    var hasEnd=!isNaN(end);
    var force=(new URLSearchParams(location.search)).get('bc')||'auto';
    var cartUrl=r0.dataset.cartUrl||'/cart';
    var pad=function(n){return String(n).padStart(2,'0')};
    function getState(now){
      if(force==='live'||force==='ended'||force==='pre')return force;
      if(window.__bcPreview)return 'live';
      if(hasEnd&&now>=end)return 'ended';
      return now>=start?'live':'pre';
    }
    function tick(){
      var now=Date.now();
      if(DAILY){end=nextMidnight(now);hasEnd=true}
      var state=getState(now);
      var open=(state==='live'&&!hasEnd);
      var target=state==='pre'?start:end;
      var diff=(state==='ended'||open)?0:Math.max(0,target-now);
      var d=Math.floor(diff/864e5),h=Math.floor(diff%864e5/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);
      roots.forEach(function(r){r.dataset.state=state});
      [].forEach.call(document.querySelectorAll('[data-bc-count]'),function(el){
        el.classList.toggle('bc-count--ended',state==='ended');
        var box=el.closest('[data-bc-lbl-live]');
        var lbl=el.querySelector('[data-bc-lbl]');
        if(lbl&&box){lbl.textContent=state==='pre'?box.dataset.bcLblPre:open?(box.dataset.bcLblOpen||'Precios Cyber vigentes por tiempo limitado'):state==='live'?box.dataset.bcLblLive:box.dataset.bcLblEnd}
        var row=el.querySelector('.bc-count__row');if(row)row.style.display=open?'none':'';
        var map={d:d,h:h,m:m,s:s};
        Object.keys(map).forEach(function(k){var n=el.querySelector('[data-bc-'+k+']');if(n)n.textContent=pad(map[k])});
      });
    }
    tick(); setInterval(tick,1000);

    var cards=[].slice.call(document.querySelectorAll('[data-bc-card]'));
    var tabs=[].slice.call(document.querySelectorAll('[data-bc-tab]'));
    tabs.forEach(function(t){
      var cat=t.dataset.bcTab;
      if(cat!=='todo'&&!cards.some(function(c){return c.dataset.cat===cat}))t.hidden=true;
      t.addEventListener('click',function(){
        tabs.forEach(function(x){x.setAttribute('aria-pressed',x===t?'true':'false')});
        cards.forEach(function(c){c.hidden=!(cat==='todo'||c.dataset.cat===cat)});
      });
    });

    var flt=document.createElement('div');flt.className='bc bc-flt';
    flt.innerHTML='<a class="bc-btn bc-btn--orange" href="'+cartUrl+'">Ver mi carro <span class="bc-flt__n">0</span></a>';
    var toast=document.createElement('div');toast.className='bc bc-toast';
    document.body.appendChild(flt);document.body.appendChild(toast);
    var fn=flt.querySelector('.bc-flt__n'),tt;
    function showToast(msg){toast.textContent=msg;toast.classList.add('is-on');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('is-on')},2600)}
    function setCount(n){fn.textContent=n;flt.classList.toggle('is-on',n>0)}
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){});
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('[data-bc-add]'); if(!b)return;
      var id=b.dataset.variant,label=b.textContent,name=b.dataset.title||'Producto';
      if(!id)return; b.disabled=true;b.textContent='Agregando…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
        .then(function(r){if(!r.ok)throw r;return fetch('/cart.js')}).then(function(r){return r.json()})
        .then(function(c){b.disabled=false;b.classList.add('is-done');b.textContent='✓ En tu carro';setCount(c.item_count);showToast(name+' quedó en tu carro');document.dispatchEvent(new CustomEvent('cart:refresh'));setTimeout(function(){b.classList.remove('is-done');b.textContent=label},2500)})
        .catch(function(){b.disabled=false;b.textContent=label;showToast('No pudimos agregarlo. Puede que se haya agotado.')});
    });
  });
})();
